import React from "react"

class IncidentalDepositPresenterAuthorizationAmount extends React.Component {
  
  constructor(props) {
    super(props)
  }

  render() {
    return(
      <div>
        <h5 className="panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF', paddingBottom: 20, paddingTop: 10 }}>{I18n.t('authorization_amount')}</h5>
        <div className="row">
          <div className="col-md-12">
            <label>{I18n.t('incidental_amount')}</label><br />
            {this.props.incidental_deposit.deposit_type == "none" ? I18n.t("none") : this.renderAuthorizationAmount()}
          </div>
        </div>

        <br />
        <br />

        <div className="row">
          {this.renderIncludeReservationBalance()}
        </div>

      </div>
    )
  }

  renderAuthorizationAmount(){
    return(
     <div>
        {this.renderAmount()}
        {this.renderPercentage()}
        {this.renderNumberOfNights()}
    </div>
    )
  }

  renderIncludeReservationBalance() {
    return(
      <div className="col-md-6">
        <div className="form-group">
        <label>{I18n.t('include_reservation_balance')} <span className="ss-help help" title={I18n.t('include_reservation_balance_helper_text')}></span></label>
          <br/>
          {this.props.incidental_deposit.include_reservation_balance ? "Yes" : "No"}
        </div>
      </div>
    )
  }

  renderAmount() {
    return(
      <div className="col-md-4">
        <div style={{marginBottom: "4px"}}>{I18n.t('amount')}</div>  
        { this.props.incidental_deposit.incidental_amount 
            ? <div> <span>{I18n.t('number.currency.format.unit')}</span>
                {(this.props.incidental_deposit.incidental_amount / 100).toFixed(2)} 
              </div> 
            : ""
        }
      </div>
    )
  }

  renderPercentage() {
    return(
      <div className="col-md-4">
        <div style={{marginBottom: "4px"}}>{I18n.t('percentage')} <span className="ss-help help" title={I18n.t('incidental_deposit_percentage_helper_text')}></span></div>
        {this.props.incidental_deposit.incidental_percentage ? <div> {parseFloat((this.props.incidental_deposit.incidental_percentage * 100).toFixed(2))}<span>%</span> </div> : ""}
      </div>
    )
  }

  renderNumberOfNights() {
    return(
      <div className="col-md-4">
        <div style={{marginBottom: "4px"}}>{I18n.t('number_of_nights')}</div>
        {this.props.incidental_deposit.incidental_nights ? <div> {this.props.incidental_deposit.incidental_nights}  </div>: ""}          
      </div>
    )
  }
}

export default IncidentalDepositPresenterAuthorizationAmount